let random = 1

export const getRandomness = () => random++

export default getRandomness
